(function() {
  function initCollectionFilters() {
    const filtersForm = document.getElementById('CollectionFiltersForm');
    const sortSelect = document.getElementById('SortBy');
    const filterToggle = document.getElementById('collection-filter-toggle');
    const filterPanel = document.getElementById('collection-filter-panel');
    const filterChevron = document.getElementById('collection-filter-chevron');

    if (filterToggle && filterPanel) {
      filterToggle.addEventListener('click', function() {
        const isOpen = filterPanel.classList.contains('is-open');
        filterPanel.classList.toggle('is-open', !isOpen);
        filterToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (filterChevron) {
          filterChevron.classList.toggle('rotate-180', !isOpen);
        }
      });
    }

    if (filtersForm) {
      // Form submits via the explicit "Apply Filter" button, no auto-submit on change
    }

    if (sortSelect && filtersForm) {
      sortSelect.addEventListener('change', function(e) {
        // Find or create hidden sort_by input inside filtersForm to submit together
        let sortInput = filtersForm.querySelector('input[name="sort_by"]');
        if (!sortInput) {
          sortInput = document.createElement('input');
          sortInput.type = 'hidden';
          sortInput.name = 'sort_by';
          filtersForm.appendChild(sortInput);
        }
        sortInput.value = e.target.value;
        filtersForm.submit();
      });
    }

    initPriceRangeSliders();
    handleCustomFilters();
  }

  function initPriceRangeSliders() {
    document.querySelectorAll('.price-range-slider').forEach(function(slider) {
      var rangeMin = slider.querySelector('.range-min');
      var rangeMax = slider.querySelector('.range-max');
      if (!rangeMin || !rangeMax) return;

      var handleId = rangeMin.id.replace('RangeMin-', '');
      var hiddenMin = document.getElementById('Filter-' + handleId + '-GTE');
      var hiddenMax = document.getElementById('Filter-' + handleId + '-LTE');
      var fill = slider.querySelector('.slider-range-fill');
      var container = slider.closest('.space-y-3') || slider.parentElement;
      var labelMin = container ? container.querySelector('.price-label-min') : null;
      var labelMax = container ? container.querySelector('.price-label-max') : null;
      var max = parseFloat(rangeMax.max) || 500;

      function update() {
        var minVal = parseInt(rangeMin.value) || 0;
        var maxVal = parseInt(rangeMax.value) || max;

        // Clamp
        if (minVal > maxVal) { rangeMin.value = maxVal; minVal = maxVal; }

        // Fill bar
        if (fill) {
          fill.style.left = (minVal / max) * 100 + '%';
          fill.style.right = (100 - (maxVal / max) * 100) + '%';
        }

        // Labels
        if (labelMin) labelMin.textContent = '$' + minVal;
        if (labelMax) labelMax.textContent = '$' + maxVal;

        // Hidden inputs
        if (hiddenMin) hiddenMin.value = minVal == 0 ? '' : minVal;
        if (hiddenMax) hiddenMax.value = maxVal == max ? '' : maxVal;
      }

      rangeMin.addEventListener('input', update);
      rangeMax.addEventListener('input', update);

      // Initial
      update();
    });
  }

  function handleCustomFilters() {
    const urlParams = new URLSearchParams(window.location.search);
    const customCheckboxes = document.querySelectorAll('.custom-filter-checkbox');
    const customActiveFiltersContainer = document.getElementById('CustomActiveFilters');
    const activeFiltersContainer = document.getElementById('ActiveFiltersContainer');
    const clearAllFilters = document.getElementById('CollectionClearAllFilters');

    if (!customCheckboxes.length) return;

    let hasActiveCustomFilter = false;

    // Clear previous custom active badges
    if (customActiveFiltersContainer) {
      customActiveFiltersContainer.innerHTML = '';
    }

    customCheckboxes.forEach(checkbox => {
      const name = checkbox.name;
      const value = checkbox.value;
      const valuesInUrl = urlParams.getAll(name);

      if (valuesInUrl.includes(value)) {
        checkbox.checked = true;
        hasActiveCustomFilter = true;

        // Render active filter badge
        if (customActiveFiltersContainer) {
          const badge = document.createElement('a');
          badge.className = 'inline-flex items-center gap-1 bg-primary/10 hover:bg-primary/20 text-primary px-3 py-1 rounded-full text-xs transition-colors font-medium no-underline cursor-pointer';
          
          // Generate human readable label
          const groupName = name === 'filter.p.product_type' ? 'Type' : 'Brand';
          badge.innerHTML = `${groupName}: ${value} <i data-lucide="x" class="w-3 h-3"></i>`;
          
          // Remove parameter when badge is clicked
          badge.addEventListener('click', function(e) {
            e.preventDefault();
            const newParams = new URLSearchParams();
            urlParams.forEach((val, key) => {
              if (key === name && val === value) return;
              newParams.append(key, val);
            });
            window.location.search = newParams.toString();
          });

          customActiveFiltersContainer.appendChild(badge);
        }
      }
    });

    // Make active container and clear all filters visible if custom filters are active
    if (hasActiveCustomFilter) {
      if (activeFiltersContainer) {
        activeFiltersContainer.classList.remove('hidden');
      }
      if (clearAllFilters) {
        clearAllFilters.classList.remove('hidden');
      }
    }

    // Reinitialize lucide icons for newly added x icon in badges
    if (hasActiveCustomFilter && typeof lucide !== 'undefined') {
      lucide.createIcons();
    }
  }

  // Load instantly
  initCollectionFilters();

  // Re-bind in Shopify Customizer
  document.addEventListener('shopify:section:load', function(e) {
    if (e.target.id.includes('collection') || e.target.querySelector('#CollectionFiltersForm')) {
      initCollectionFilters();
    }
  });
})();
